import algoliasearch from 'algoliasearch/lite';
import { history as historyRouter } from 'instantsearch.js/es/lib/routers';
import { singleIndex as singleIndexMapping } from 'instantsearch.js/es/lib/stateMappings';
import { getValueFromMeta } from './getValueFromMeta';

/*
    Site ID & Key
*/

const elm = document.getElementById('_algolia');
let appData = null;
if (elm) {

    appData = JSON.parse(elm.getAttribute('content'));

}

const ALGOLIA_APP_ID = appData ? appData.app_id : '6UELVWAN8K';
const ALGOLIA_APP_KEY = appData ? appData.api_key : '72c19fe260bbd8411f7e367573151af8';

/*
    searchClient
*/
const searchClient = algoliasearch(
    ALGOLIA_APP_ID,
    ALGOLIA_APP_KEY,
);

/*
    env
*/
const env = (getValueFromMeta('x-env') ? getValueFromMeta('x-env') : 'live');
const indexName = `${env}_Pages`;

export {
    ALGOLIA_APP_ID,
    ALGOLIA_APP_KEY,
    searchClient,
    env,
    indexName,
};
